import React from 'react';
import { Box, Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { youtubeId } from './videoStage';
import { isNative } from '../utils/platformUtils';
import { openExternal } from '../lib/openExternal';

const VideoDialog = ({ url, onClose }) => {
  const id = youtubeId(url);

  return (
    <Dialog
      open={!!url}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { backgroundColor: 'transparent', boxShadow: 'none', m: 2, width: 'calc(100% - 32px)' } }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
        <IconButton
          aria-label="Close video"
          onClick={onClose}
          sx={{ width: 44, height: 44, color: 'white', backgroundColor: 'rgba(255,255,255,0.12)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' } }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ position: 'relative', width: '100%', aspectRatio: '16 / 9', backgroundColor: '#000', borderRadius: '16px', overflow: 'hidden' }}>
        {id ? (
          <Box
            component="iframe"
            src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0`}
            title="Video"
            allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
          />
        ) : url ? (
          <Box
            component="video"
            data-testid="pack-video"
            src={url}
            controls
            playsInline
            autoPlay
            sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', display: 'block', objectFit: 'contain' }}
          />
        ) : null}
      </Box>
    </Dialog>
  );
};

export const openVideo = (url, setVideoUrl) => {
  if (!url) return;
  if (isNative() && youtubeId(url)) openExternal(url);
  else setVideoUrl(url);
};

export default VideoDialog;
